import * as React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "./style/global.scss";

import Login from "./pages/Login";

import Error404 from "./pages/Error404";
import Objave from "./pages/Objave/Objave";
import NovaObjava from "./pages/Objave/NovaObjava";
import Kategorije from "./pages/Kategorije/Kategorije";
import Notification from "src/components/UI/Notification";
import RootLayout from "./pages/Root";
import { useAppSelector } from "./store";
import EditObjava from "./pages/Objave/EditObjava";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InterneObjave from "./pages/InterneObjave/InterneObjave";
import InternaObjava from "./pages/InterneObjave/InternaObjava";

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <Error404 />,
    children: [
      {
        index: true,
        element: <Objave />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/objave",
        element: <Objave />,
      },
      {
        path: "/objave/nova-objava",
        element: <NovaObjava />,
      },
      {
        path: "/objave/edit-objava/:id",
        element: <EditObjava />,
      },
      {
        path: "/kategorije",
        element: <Kategorije />,
      },
      {
        path: "/interne-objave/:hash",
        element: <InterneObjave />,
      },

      {
        path: "/interne-objave/:hash/:id",
        element: <InternaObjava />,
      },
    ],
  },
]);

function App() {
  const notification = useAppSelector((state: any) => state.ui.notification);
  const isAuth = useAppSelector((state: any) => state.login.isAuthenticated);
  const location = window.location.href.includes("interne-objave");

  return (
    <React.Fragment>
      {!isAuth && !location && <Login />}
      {(isAuth ||
        location) && (
          <>
            {notification && (
              <Notification
                status={notification.status}
                title={notification.title}
              />
            )}
            <RouterProvider router={router} />
          </>
        )}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
      />
    </React.Fragment>
  );
}

export default App;
